import { SPage, SPageListProps } from 'servisofts-component';

import location from "./location"
export default SPage.combinePages("info", {
    location,

});